import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteDeviceDetectionJobByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteDeviceDetectionJobByIdMutation = { __typename?: 'mutation_root', delete_device_detection_jobs_by_pk?: { __typename?: 'device_detection_jobs', id: any } | null };


export const DeleteDeviceDetectionJobByIdDocument = gql`
    mutation deleteDeviceDetectionJobById($id: uuid!) {
  delete_device_detection_jobs_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteDeviceDetectionJobByIdMutationFn = Apollo.MutationFunction<DeleteDeviceDetectionJobByIdMutation, DeleteDeviceDetectionJobByIdMutationVariables>;

/**
 * __useDeleteDeviceDetectionJobByIdMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceDetectionJobByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceDetectionJobByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceDetectionJobByIdMutation, { data, loading, error }] = useDeleteDeviceDetectionJobByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceDetectionJobByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceDetectionJobByIdMutation, DeleteDeviceDetectionJobByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceDetectionJobByIdMutation, DeleteDeviceDetectionJobByIdMutationVariables>(DeleteDeviceDetectionJobByIdDocument, options);
      }
export type DeleteDeviceDetectionJobByIdMutationHookResult = ReturnType<typeof useDeleteDeviceDetectionJobByIdMutation>;
export type DeleteDeviceDetectionJobByIdMutationResult = Apollo.MutationResult<DeleteDeviceDetectionJobByIdMutation>;
export type DeleteDeviceDetectionJobByIdMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceDetectionJobByIdMutation, DeleteDeviceDetectionJobByIdMutationVariables>;